"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var signalr_1 = require("@aspnet/signalr");
var __1 = require("../");
var REACT_APP_SIGNALR_SERVER_URL = process.env.REACT_APP_SIGNALR_SERVER_URL;
var connection = null;
var connectionInterval = null;
var onConnectionRestoredQue = [];
var startConnection = function (onConnectionRestored) { return __awaiter(_this, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, connection.start()];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                console.error("SignalR connection error: ", err_1);
                startConnectionPolling(onConnectionRestored);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
var startConnectionPolling = function (onConnectionRestored) {
    clearInterval(connectionInterval);
    connectionInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, connection.start()];
                case 1:
                    _a.sent();
                    clearInterval(connectionInterval);
                    onConnectionRestoredQue.forEach(function (cb) { return cb(); });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error("SignalR connection error: ", err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, 5000);
};
var initConnection = function (url, onConnectionRestored) {
    connection = new signalr_1.HubConnectionBuilder()
        .withUrl(url, {
        accessTokenFactory: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.acquireToken()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); },
    })
        .build();
    connection.onclose(function () {
        startConnection(onConnectionRestored);
    });
    return startConnection(onConnectionRestored);
};
var subscribeConnection = function (events) {
    events.forEach(function (_a) {
        var name = _a[0], callback = _a[1];
        return connection.on(name, callback);
    });
};
var unsubscribeConnection = function (events) {
    events.forEach(function (_a) {
        var name = _a[0], callback = _a[1];
        return connection.off(name, callback);
    });
};
var ApSignalrConsumer = /** @class */ (function (_super) {
    __extends(ApSignalrConsumer, _super);
    function ApSignalrConsumer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.events = [];
        _this.componentDidUnmount = false;
        _this.onConnectionRestored = function () {
            if (_this.props.onConnectionRestored) {
                _this.props.onConnectionRestored();
            }
        };
        return _this;
    }
    ApSignalrConsumer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!REACT_APP_SIGNALR_SERVER_URL || this.componentDidUnmount) {
                            return [2 /*return*/];
                        }
                        if (!!connection) return [3 /*break*/, 2];
                        return [4 /*yield*/, initConnection(REACT_APP_SIGNALR_SERVER_URL)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.props.onConnectionRestored) {
                            onConnectionRestoredQue.push(this.onConnectionRestored);
                        }
                        message = this.props.message;
                        // subscribe to connection events
                        if (!Array.isArray(message)) {
                            this.events.push([message, this.onMessage.bind(this, message)]);
                        }
                        else {
                            this.events = message.map(function (m) { return [m, _this.onMessage.bind(_this, m)]; });
                        }
                        subscribeConnection(this.events);
                        return [2 /*return*/];
                }
            });
        });
    };
    ApSignalrConsumer.prototype.componentWillUnmount = function () {
        var _this = this;
        this.componentDidUnmount = true;
        unsubscribeConnection(this.events);
        onConnectionRestoredQue = onConnectionRestoredQue.filter(function (cb) { return cb !== _this.onConnectionRestored; });
    };
    ApSignalrConsumer.prototype.onMessage = function (message) {
        var _a;
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        console.log.apply(console, ["Signal log", message].concat(data));
        (_a = this.props).onMessage.apply(_a, [message].concat(data));
    };
    ApSignalrConsumer.prototype.render = function () {
        return null;
    };
    return ApSignalrConsumer;
}(react_1.default.Component));
exports.ApSignalrConsumer = ApSignalrConsumer;
//# sourceMappingURL=ApSignalrConsumer.js.map